import { trackPromise } from 'react-promise-tracker';
import api from '../../../../utils/API';

export const getAnaliseCoberturaBigNumbers = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/big-numbers`,
      method: 'POST',
      expectToken: true,
      data,
    }).then(resp => resp),
    'analise-cobertura',
  );

export const getAnaliseCoberturaTimeline = () =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/big-numbers/history/timeline`,
      method: 'GET',
      params: {
        page: 0,
        size: 10,
      },
      expectToken: true,
    }).then(resp => resp),
    'analise-cobertura-timeline',
  );

export const getAnaliseCoberturaRede = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-rede`,
      method: 'GET',
      params: {
        page: data.page,
        size: 10,
        diasAnalise: data.diasAnalise,
        query: data.query,
      },
      expectToken: true,
    }).then(resp => resp),
    'analise-cobertura-rede',
  );

export const downloadHistoricoCobertura = () =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/big-numbers/history/timeline/download`,
      method: 'GET',
      expectToken: true,
      responseType: 'arraybuffer',
    })
      .then(resp => resp)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'historico_cobertura.csv';
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'analise-cobertura-timeline',
  );

export const getCoverageAnalysisSection = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-secao`,
      method: 'POST',
      params: {
        page: data.page,
        size: data.size || 10,
        diasAnalise: data.diasAnalise,
        query: data.query,
      },
      data: { filtro: data.filtro || [] },
      expectToken: true,
    }).then(resp => resp),
    'coverage-analysis-section',
  );

export const getCoverageAnalysisUf = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-uf`,
      method: 'POST',
      params: {
        page: data.page,
        size: data.size || 10,
        diasAnalise: data.diasAnalise,
        query: data.query,
      },
      data: { filtro: data.filtro || [] },
      expectToken: true,
    }).then(resp => resp),
    'coverage-analysis-uf',
  );

export const getCoverageAnalysisCategory = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-categoria`,
      method: 'POST',
      params: {
        page: data.page,
        size: data.size || 10,
        diasAnalise: data.diasAnalise,
        query: data.query,
      },
      data: { filtro: data.filtro || [] },
      expectToken: true,
    }).then(resp => resp),
    'coverage-analysis-category',
  );

export const getCoverageAnalysisCity = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-cidade`,
      method: 'POST',
      params: {
        page: data.page,
        size: data.size || 10,
        diasAnalise: data.diasAnalise,
        query: data.query,
      },
      data: { filtro: data.filtro || [] },
      expectToken: true,
    }).then(resp => resp),
    'coverage-analysis-city',
  );

export const downloadProductNotFound = (data: { numeroDias: number; dataFinal: string }) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_COVERAGE_ENGINE_URL}/gtins-nao-encontrados/download`,
      method: 'GET',
      params: {
        numeroDias: data?.numeroDias || 0,
        dataFinal: data?.dataFinal || '',
      },
      expectToken: true,
      responseType: 'arraybuffer',
    })
      .then(resp => resp)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'produtos-nao-encontrados.csv';
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'analise-cobertura',
  );
